
/**
 * IStoryPlayer is an interface for implementations that can serialize and
 * deserialize a Story
 * @constructor
 * @returns {undefined}
 */
export default class IStoryParser {

     /**
     * Serialize a Story
     * @param {Story} story
     * @returns {*} Serialized data for the Story
     */
     serializeStory(story) {
     }
     /**
     * Parse data and deserialize a Story from it
     * @param {*} input Data to be processed
     * @returns {Story} The Story
     */
     parseStory(input) {
     }
}
